export enum PersonTypeEnum {
    LegacyPerson = 'LegacyPerson',
    PhysicalPerson = 'PhysicalPerson',
    LegalPerson = 'LegalPerson'
}
